import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";

interface IStartIconButtonProps extends ButtonProps {
    startIcon?: React.ReactNode;
}

export const StartIconButton = ({
    children,
    startIcon,
    ...rest
}: IStartIconButtonProps) => {
    return (
        <Button
            variant="contained"
            startIcon={startIcon}
            sx={{ pt: 1, pr: 3, borderRadius: "18px" }}
            {...rest}
        >
            {children}
        </Button>
    );
};
